export enum RoutineType {
  morning = "morning",
  evening = "evening"
}

export const RoutineTypeFields = {
  [RoutineType.morning] : "morningRoutine",
  [RoutineType.evening] : "eveningRoutine"
}
